module.exports = __webpack_public_path__ + "img/active-third.1c03d846.png";